import { defineStore } from "pinia";
import ListUtil from '../../utils/pricetravel/list/utils';

const paramQuery = {};
const config = { listItemsCount: 10, siteUrl: '', pathHotelDetail: '' };
const separator = '...';
const site = window.__pt.settings.site;

const listUtil = new ListUtil(paramQuery, config, separator);

export const useUserStore = defineStore('user', {
    state: () => ({
        user: window.__pt.user || {
            createdAt: new Date(),
            deletedAt: null,
            firebaseId: null,
            id: null,
            rememberToken: null,
            reservation: null,
            site: null,
            token: null, type: "",
            updatedAt: null,
            userProfile: {}
        },
        newPaxe: {
            firstName: '',
            lastName: '',
            birthdate: null,
            day_user: '',
            month_user: '',
            year_user: '',
            nationality: '',
            telephone: '',
            gender: '',
            email: '',
            passport: '',
            accepted: false,
            disabled: false
        },
        reservations: {},
        userProfile: {
            name: '',
            last_name: '',
            birthdate: null,
            day_user: '',
            month_user: '',
            year_user: '',
            nationality: '',
            telephone: '',
            codePhone: '',
            genre: '',
            email: '',
            passport: '',
            passengers: [],
        },
        pagination: {
            currentPage: 1,
            buttons: [],
            endPage: 0,
            render: [],
            startPage: 0,
            totalPages: 0
        },
        birthdateParts: ["", "", ""],
        category: 'upcoming',
        cache: true,
        isLoading: true,
        totalReservations: 0,
        reservationsUpcoming: {},
        reservationsPending: {},
        reservationsQuotes: {},
        reservationsCompleted: {},
        reservationsCancelled: {},
        originalUser: null
    }),
    getters: {
        getUser: (state) => state.user,
        getEmail: (state) => state.user.userProfile.contactEmail,
        getUserProfile: (state) => state.userProfile,
        getReservations: (state) => {
            const map = {
                'pending': state.reservationsQuotes,
                'upcoming': state.reservationsUpcoming,
                'pending-payment': state.reservationsPending,
                'completed': state.reservationsCompleted,
                'cancelled': state.reservationsCancelled
            };

            return map[state.category] || {};
        },
        getPaxes: (state) => state.paxes,
        getPagination: (state) => state.pagination,
        getCurrentPage: (state) => state.pagination.currentPage,
        getLoading: (state) => state.isLoading,
        getCategory: (state) => state.category,
        getPassenger: (state) => state.userProfile.passengers,
        getNewPaxe: (state) => state.newPaxe,
        getTotalReservations: (state) => state.totalReservations,
        getUpcomingData: (state) => state.reservationsUpcoming.data?.length ?? 0,
        getPendingData: (state) => state.reservationsPending.data?.length ?? 0,
        getQuotesData: (state) => state.reservationsQuotes.data?.length ?? 0,
        getCompletedData: (state) => state.reservationsCompleted.data?.length ?? 0,
        getCancelledData: (state) => state.reservationsCancelled.data?.length ?? 0,
        getCategoryWithData: (state) => {
            const categories = [
                { key: 'pending', data: state.reservationsQuotes },
                { key: 'upcoming', data: state.reservationsUpcoming },
                { key: 'pending-payment', data: state.reservationsPending },
                { key: 'completed', data: state.reservationsCompleted },
                { key: 'cancelled', data: state.reservationsCancelled },
            ];

            const categoryWithData = categories.find((category) => {
                const data = category.data?.data ?? [];
                return Array.isArray(data) && data.length > 0;
            });
            return categoryWithData ? categoryWithData.key : null;
        }
    },
    actions: {
        setUser(user) {
            this.user = user;
        },
        setUserProfile(profile) {
            this.userProfile = profile;
        },
        copyOriginalData(data) {
            this.originalUser = JSON.parse(JSON.stringify(data));
        },
        setReservation(reservations) {
            this.reservations = reservations;
        },
        setPaxes(paxes) {
            this.paxes = paxes;
        },
        setNationality(nationality) {
            this.userProfile.nationality = nationality;
        },
        setNationalityNewPaxe(nationality) {
            this.newPaxe.nationality = nationality;
        },
        setBirthday(birthday) {
            this.userProfile.birthdate = birthday;
        },
        setBirthdayNewPaxe(birthdate) {
            this.newPaxe.birthdate = birthdate;
        },
        setPagination(total, currentTotal) {
            this.pagination = listUtil.buildPaginator(total, currentTotal, this.pagination.currentPage, 2)
        },
        setLoading(loading) {
            this.isLoading = loading;
        },
        setBithdateParts(date) {
            if (date != null) {
                let parts = date.split("/");
                this.userProfile.day_user = parts[0];
                this.userProfile.month_user = parts[1];
                this.userProfile.year_user = parts[2];
            }
        },
        setCurrentPage(page) {
            this.pagination.currentPage = page;
        },
        setReservations(reservations) {
            const map = {
                'upcoming': 'reservationsUpcoming',
                'pending': 'reservationsQuotes',
                'pending-payment': 'reservationsPending',
                'completed': 'reservationsCompleted',
                'cancelled': 'reservationsCancelled'
            };
            const key = map[this.category];
            if (key) {
                this[key].data = reservations;
            } else {
                console.warn(`Categor�a no v�lida: ${this.category}`);
            }
        },
        setCategoryName(category) {
            switch (category) {
                case "upcoming":
                    this.setTotalReservations(this.reservationsUpcoming.total);
                    this.setPagination(this.reservationsUpcoming.total, this.reservationsUpcoming.perPage);
                    break;
                case "pending":
                    this.setTotalReservations(this.reservationsQuotes.total);
                    this.setPagination(this.reservationsQuotes.total, this.reservationsQuotes.perPage);
                    break;
                case "pending-payment":
                    this.setTotalReservations(this.reservationsPending.total);
                    this.setPagination(this.reservationsPending.total, this.reservationsUpcoming.perPage);
                    break;
                case "completed":
                    this.setTotalReservations(this.reservationsCompleted.total);
                    this.setPagination(this.reservationsCompleted.total, this.reservationsCompleted.perPage);
                    break;
                default:
                    this.setTotalReservations(this.reservationsCancelled.total);
                    this.setPagination(this.reservationsCancelled.total, this.reservationsCancelled.perPage);
                    break;
            }

            this.category = category;
        },
        setCache(cache) {
            this.cache = cache;
        },
        setNewPassenger(passenger) {
            this.passenger.push(passenger);
        },
        setCodePhone(dialCode) {
            this.userProfile.codePhone = dialCode + "";
        }, 
        resetNewPaxe() {
            this.newPaxe = {
                name: '',
                last_name: '',
                birthdate: null,
                day_user: '',
                month_user: '',
                year_user: '',
                nationality: '',
                telephone: '',
                genre: '',
                email: '',
                passport: '',
                accepted: true,
                disabled: false
            };
        },
        disablePassenger(index) {
            
            if (this.userProfile.passengers[index]) {
                this.userProfile.passengers[index].disabled = true
            }
        },
        setTotalReservations(total) {
            this.totalReservations = total;
        },
        addNewPaxe() {
            let newPax = this.getNewPaxe;
            newPax.Birthdate = `${newPax.day_user}/${newPax.month_user}/${newPax.year_user}`;


            this.userProfile.passengers.push(newPax);
        },
        async getReservationService() {
            this.setLoading(true);
            let response = await axios.get(site.siteUrl + `/hotel/api/user/bookings?page=${this.pagination.currentPage}&category=${this.category}&cache=${this.cache}`).catch((data) => this.onError(data, 'error'));

            if (response && response.status === 200) {
                this.setTotalReservations(response.data.total);
                this.setReservations(response.data.data);
                this.setPagination(response.data.total, response.data.perPage);
                this.setCategoryName(this.getCategoryWithData);
                this.setLoading(false);
            }
        },
        async setPage(page) {                            
            this.cache = false;
            this.pagination.currentPage = page;
            await this.getReservationService();
        },
        async getAllReservations() {
            this.setLoading(true);

            const categories = [
                { key: 'pending', stateKey: 'reservationsQuotes' },
                { key: 'upcoming', stateKey: 'reservationsUpcoming' },
                { key: 'pending-payment', stateKey: 'reservationsPending' },
                { key: 'completed', stateKey: 'reservationsCompleted' },
                { key: 'cancelled', stateKey: 'reservationsCancelled' }
            ];

            try {
                const [firstCategory, ...restCategories] = categories;

                const firstRes = await axios.get(`${site.siteUrl}/hotel/api/user/bookings`, {
                    params: {
                        page: this.pagination.currentPage,
                        category: firstCategory.key,
                        cache: true
                    }
                }).catch(error => ({ error, key: firstCategory.key }));

                const results = [firstRes];

                const restPromises = restCategories.map(({ key }) =>
                    axios.get(`${site.siteUrl}/hotel/api/user/bookings`, {
                        params: {
                            page: this.pagination.currentPage,
                            category: key,
                            cache: false
                        }
                    }).catch(error => ({ error, key }))
                );

                const restResults = await Promise.all(restPromises);
                results.push(...restResults);

                results.forEach((res, index) => {
                    const { key, stateKey } = categories[index];

                    if (res.error) {
                        console.log(res.error);
                        return;
                    }

                    if (res && res.status === 200) {
                        const data = res.data;
                        this[stateKey] = {
                            total: data.total,
                            perPage: data.perPage,
                            data: data.data
                        };
                    }
                });

                this.setCategoryName(this.getCategoryWithData);
            } catch (err) {
                this.onError(err, 'Error general al obtener las reservas');
            } finally {
                this.setLoading(false);
            }
        },
        resetUser() {
            if (this.originalUser) {
                this.userProfile = JSON.parse(JSON.stringify(this.originalUser));
            }
        }
    }
});